import { makeAutoObservable } from 'mobx';

interface IUsersPermissionsModel {
  permissions: string[];
}

// Token permission claims carry an `@app` app-scope suffix (e.g. `FBS.ManageUsers@FB`).
// Match on the bare name only, so a permission is honoured regardless of which app it was
// scoped to — mirroring the backend, which authorizes on the suffix-less permission name.
const basePermission = (permission: string): string => {
  const at = permission.indexOf('@');
  return at === -1 ? permission : permission.substring(0, at);
};

class ApplicationUserRightsStore {
  permissions: string[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  // These checks are UX-only — the backend enforces the real security via [TrackManAuthorize].
  // We still aim to match what the backend would allow, so the UI shows exactly what the user
  // can actually use (avoiding menu items / pages that then 403 on their data calls).
  public IsAllowed(requiredPermissions: string[] | string): boolean {
    const held = new Set((this.permissions ?? []).map(basePermission));

    // An array means all listed permissions are required (an empty array requires none).
    if (Array.isArray(requiredPermissions)) {
      return requiredPermissions.every((p) => held.has(basePermission(p)));
    }

    return held.has(basePermission(requiredPermissions));
  }

  setData(data: IUsersPermissionsModel) {
    this.permissions = data.permissions;
  }
}

export const ApplicationUserRights = new ApplicationUserRightsStore();
